import React from "react";
import { Input, SelectMenu } from "@zorni/components-lib";
import { useTranslation } from "react-i18next";

import styles from "./AddUser.module.css";

const AddUser = ({
  values,
  onChange,
  roleOptions,
  establishmentOptions,
  errors = {},
}) => {
  const { t } = useTranslation();

  return (
    <div className={styles.form}>
      <Input
        floatHeight={50}
        floatRound
        floatStrong
        floatingLabel
        label={t("manageUsers.columns.mail")}
        name="email"
        type="email"
        inputSize="small"
        value={values.email}
        placeholder={t("manageUsers.modal.emailPlaceholder")}
        onChange={(event) => onChange("email", event.target.value)}
        errors={errors.email}
      />

      <SelectMenu t={t}
        name="establishment"
        placeholder={t("manageUsers.columns.establishment")}
        options={establishmentOptions}
        value={values.establishment?.id}
        inputSize="small"
        errors={errors.establishment}
        onChange={(value, option) =>
          onChange("establishment", {
            id: option.value,
            name: option.text,
          })
        }
      />

      <SelectMenu t={t}
        name="role"
        placeholder={t("manageUsers.columns.role")}
        options={roleOptions}
        value={values.role?.value}
        disabled={!values.establishment || roleOptions.length === 0}
        inputSize="small"
        errors={errors.role}
        onChange={(value, option) =>
          onChange("role", {
            value: option.value,
            text: option.text,
          })
        }
      />
    </div>
  );
};

export default AddUser;
